<template>
  <component :is="component">{{ converted }}</component>
</template>

<script>
import * as dateHelper from '@/utils/date-helper'

export default {
  name: 'BrbDateTimeDisplay',
  props: {
    date: {
      validator: (value) =>
        value === null ||
        typeof value === 'string' ||
        typeof value === 'number',
      required: true
    },
    component: {
      type: String,
      default: 'span'
    },
    placeholder: {
      type: String,
      default: '-'
    },
    dateTime: Boolean,
    dateTimeSec: Boolean,
    time: Boolean,
    dayName: Boolean,
    dayNameDate: Boolean,
    dayNameDateTime: Boolean,
    secsToTime: Boolean
  },
  computed: {
    converted() {
      if (!this.date) return this.placeholder

      if (this.date === this.$config.infinityTime) return '∞'

      if (this.dateTime)
        return `${dateHelper.jalaaliFullDate(
          this.date
        )} - ${dateHelper.jalaaliTime(this.date)}`

      if (this.dateTimeSec)
        return `${dateHelper.jalaaliFullDate(
          this.date
        )} - ${dateHelper.jalaaliTimeWithSecs(this.date)}`

      if (this.dayName) return dateHelper.jalaaliWeekDayName(this.date)

      if (this.time) return dateHelper.jalaaliTime(this.date)

      if (this.dayNameDate)
        return `${dateHelper.jalaaliWeekDayName(
          this.date
        )}، ${dateHelper.jalaaliFullDate(this.date)} `

      if (this.dayNameDateTime)
        return `${dateHelper.jalaaliWeekDayName(
          this.date
        )}، ${dateHelper.jalaaliFullDate(this.date)} - ${dateHelper.jalaaliTime(
          this.date
        )}`

      if (this.secsToTime) {
        const result = dateHelper.ssToHhMm(this.date)
        if (!result) return this.placeholder
        return `${result.hour ? `${result.hour} ${this.$t('unit.hour')}` : ''}${
          result.hour && result.minutes ? ` ${this.$t('shared.and')} ` : ''
        }${
          result.minutes ? `${result.minutes} ${this.$t('unit.minutes')}` : ''
        }`
      }

      return dateHelper.jalaaliFullDate(this.date)
    }
  }
}
</script>
